import Api from '../api'
import { parseError } from '~/error/parser'
function getFilter (file) {
  let filter = { 'id': file.file_uuid }
  switch (file.type) {
    case 'dicom-vault':
    case 'document-vault':
      filter.type = file.type
      break
    case 'study':
    case 'directory':
      filter = { 'path': { 'id': file.file_uuid, 'descendant': true } }
  }
  return filter
}

export function joinPath (base = '', path = '') {
  if (base.endsWith('/')) {
    return base + path
  }
  return base + '/' + path
}

export default {
  namespaced: true,
  state: {
    tasks: []
  },
  getters: {
    tasks: state => state.tasks
  },
  mutations: {
    setTasks (state, tasks) {
      state.tasks = tasks
    },
    pushTask (state, task) {
      state.tasks.push(task)
    },
    clear (state) {
      state.tasks = []
    }
  },
  actions: {
    async checkCanCopyTask ({ dispatch, commit }, { file }) {
      if (file.type === 'dicom_vault' || file.type === 'document_vault') {
        return true
      }
      try {
        const { data } = await Api.postV2('task/files/validate-copy', {
          data: {
            'filter': getFilter(file),
            'create_pointers': true
          }
        })
        return data
      } catch (rs) {
        let err = rs
        if (rs && rs.body && Array.isArray(rs.body.errors) && rs.body.errors.length > 0) {
          err = rs.body.errors[0]
        }
        dispatch('feedback/addErrSnack', parseError(err), {root: true})
        throw err
      }
    },
    async copyFilesTask ({ dispatch, commit }, { file, morph = {}, createPointers = false, remoteInfo }) {
      let remote = remoteInfo && remoteInfo.address ? joinPath(remoteInfo.address.url, remoteInfo.address.scope) : remoteInfo
      try {
        const { data } = await Api.postV2('task/files/copy', {
          data: {
            'filter': getFilter(file),
            'create_pointers': createPointers,
            'morph_template': morph,
            'remote': remote
          }
        })
        commit('pushTask', data.task_id)

        return data.task_id
      } catch (rs) {
        let err = rs
        if (rs && rs.body && Array.isArray(rs.body.errors) && rs.body.errors.length > 0) {
          err = rs.body.errors[0]
        }
        dispatch('feedback/addErrSnack', parseError(err), {root: true})
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/idonia-api/tasks/tasks.js